import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {Localization} from '../../enums/localization';
import {UntypedFormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, shareReplay} from 'rxjs/operators';

@Component({
  selector: 'app-dropdown-selection',
  templateUrl: './dropdown-selection.component.html',
  styleUrls: ['./dropdown-selection.component.scss']
})
export class DropdownSelectionComponent<SelectionType> implements OnChanges {

  @Input()
  public options: SelectionType[];
  @Input()
  public presentUsing: (keyof SelectionType) | ((selection: SelectionType) => any);
  @Input()
  public placeHolder = Localization.Select;
  @Input()
  public presentCoverUsing: keyof SelectionType;
  @Input()
  public fallbackCover;
  @Input()
  selectionFormControl = new UntypedFormControl();

  @Output()
  public selection = new EventEmitter<SelectionType>();
  public selection$ = this.selection.asObservable();

  public Localization = Localization;

  public reference$: Observable<string> = this.selection.asObservable().pipe(
    map(selection => this.referenceFrom(selection)),
    shareReplay(),
  );

  public hasReference$ = this.reference$.pipe(
    map(reference => !!reference)
  );

  public coverUrl$: Observable<string> = this.selection.asObservable().pipe(
    map(selection => this.coverUrlFrom(selection)),
  );

  public hasCoverUrl$ = this.coverUrl$.pipe(
    map(url => url !== this.fallbackCover)
  );

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.options.currentValue?.length && changes.options.previousValue === null) {
      this.selectFirstOption();
    }
  }

  private coverUrlFrom(selection: SelectionType): string {
    const selectionCoverUrl = selection?.[this.presentCoverUsing];
    if (typeof selectionCoverUrl === 'string') {
      return selectionCoverUrl;
    }
    return this.fallbackCover;
  }

  private referenceFrom(selection: SelectionType): string {
    let referenceLabel;
    if (typeof this.presentUsing === 'string') {
      referenceLabel = selection?.[this.presentUsing];
    } else if (typeof this.presentUsing === 'function') {
      referenceLabel = this.presentUsing(selection);
    }
    if (typeof referenceLabel === 'string') {
      return referenceLabel;
    }
    return '';
  }

  private selectFirstOption(): void {
    this.selectionFormControl.patchValue(this.options[0]?.['id']);
    this.selection.emit(this.options[0]);
  }
}


